import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export interface Ipa {
  RmiCompanyId: string,
  RmiCompanyFullName: string
}

export interface ResourceFiles {
  RmiCompanyId: string,
  RmiCreatedBy: string,
  RmiCreatedDate: string,
  RmiFileDesc: string,
  RmiFileName: string,
  RmiLanguage: string,
  RmiLocationPath: string,
  RmiMaterialType: string,
  RmiModifiedBy: string,
  RmiModifiedDate: string,
  documentFileLocation: string,
  File: any,
};

export interface DocumentFiles {
  RmiCompanyId: string,
  RmiCreatedBy: string,
  RmiCreatedDate: string,
  RmiFileDesc: string,
  RmiFileName: string,
  RmiLanguage: string,
  RmiLocationPath: string,
  RmiMaterialType: string,
  RmiModifiedBy: string,
  RmiModifiedDate: string,
  CompanyIds: string,
  SpecCodes: string,
  ProviderIds: string,
  File: any,
};

export const getContractedIPA = (userId: string) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.GET_CONTRACTED_IPA_REQUEST });

  return api.app.ipa.getContractedIPA(userId)
    .then((res: any) => {

      dispatch({
        type: types.GET_CONTRACTED_IPA_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_CONTRACTED_IPA_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getAll = (userId: string) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.GET_ALL_IPAS_REQUEST });

  return api.app.ipa.getAll(userId)
    .then((res: any) => {

      dispatch({
        type: types.GET_ALL_IPAS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_ALL_IPAS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getAllDesc = () => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.GET_ALL_IPAS_DESC_REQUEST });

  return api.app.ipa.getAllDesc()
    .then((res: any) => {

      dispatch({
        type: types.GET_ALL_IPAS_DESC_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_ALL_IPAS_DESC_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getEzcapIpasDesc = () => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.GET_ALL_IPAS_DESC_REQUEST });

  return api.app.ipa.getEzcapIpasDesc()
    .then((res: any) => {

      dispatch({
        type: types.GET_ALL_IPAS_DESC_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_ALL_IPAS_DESC_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getResources = (userId: string, materialType: string, measureCode: string) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.GET_IPA_RESOURCES_REQUEST });

  return api.app.ipa.getResources(userId, materialType, measureCode)
    .then((res: any) => {

      dispatch({
        type: types.GET_IPA_RESOURCES_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_IPA_RESOURCES_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const deleteResource = (formObject: any) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.DELETE_RESOURCES_REQUEST });

  return api.app.ipa.deleteResource(formObject)
    .then((res: any) => {

      dispatch({
        type: types.DELETE_RESOURCES_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.DELETE_RESOURCES_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const updateResource = (formObject: any) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.UPDATE_RESOURCES_REQUEST });

  return api.app.ipa.updateResource(formObject)
    .then((res: any) => {

      dispatch({
        type: types.UPDATE_RESOURCES_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.UPDATE_RESOURCES_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const uploadResource = (formObject: any) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.UPLOAD_RESOURCES_REQUEST });

  return api.app.ipa.uploadResource(formObject)
    .then((res: any) => {

      dispatch({
        type: types.UPLOAD_RESOURCES_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.UPLOAD_RESOURCES_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const uploadProviderResources = (formObject: any) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.UPLOAD_PROVIDER_RESOURCES_REQUEST });

  return api.app.ipa.uploadProviderResources(formObject)
    .then((res: any) => {

      dispatch({
        type: types.UPLOAD_PROVIDER_RESOURCES_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.UPLOAD_PROVIDER_RESOURCES_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const searchProviderByName = (UserId: string, PageSize: string, ProviderName: string, CompanyIds: any) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.SEARCH_PROVIDER_REQUEST });

  const formObject = {
    UserId: UserId,
    PageSize: PageSize,
    ProviderName: ProviderName,
    CompanyIds: CompanyIds
  }

  return api.app.ipa.searchProviderByName(formObject)
    .then((res: any) => {

      dispatch({
        type: types.SEARCH_PROVIDER_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.SEARCH_PROVIDER_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const searchSpecialtyName = (UserId: string, PageSize: string, SpecialtyName: string, CompanyIds: any) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.SEARCH_SPECIALTY_REQUEST });

  const formObject = {
    UserId: UserId,
    PageSize: PageSize,
    SpecialtyName: SpecialtyName,
    CompanyIds: CompanyIds
  }

  return api.app.ipa.searchSpecialtyName(formObject)
    .then((res: any) => {

      dispatch({
        type: types.SEARCH_SPECIALTY_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.SEARCH_SPECIALTY_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const deleteProviderResources = (formObject: any) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.DELETE_DOCUMENTS_REQUEST });

  return api.app.ipa.deleteProviderResources(formObject)
    .then((res: any) => {

      dispatch({
        type: types.DELETE_DOCUMENTS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.DELETE_DOCUMENTS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const updateProviderResources = (params: any) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.UPDATE_DOCUMENTS_REQUEST });

  return api.app.ipa.updateProviderResources(params)
    .then((res: any) => {

      dispatch({
        type: types.UPDATE_DOCUMENTS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.UPDATE_DOCUMENTS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};